<div>
	<form id="form"
							enctype="application/x-www-form-urlencoded"
							(keyup.enter)="useGoogleCaptcha ? false : requestAccess()">
		<div class="form-group email">
			<input class="form-control"
										type="email"
										name="email"
										autocomplete="email"
										placeholder="{{'EMAIL_PLACEHOLDER' | translate}}"
										(keyup)="checkErrorState()"
										[(ngModel)]="username"
										[readonly]="identityEstablished"
										required>
		</div>
		<div class="form-group" *ngIf="useGoogleCaptcha">
			<div class="mb-1 g-recaptcha-container request-access" [innerHtml]="captchaHtml">
			</div>
		</div>
		<div matTooltip="{{getErrorMessage()}}"
							matTooltipPosition="above"
							[matTooltipDisabled]="!isErrorState">
			<ng-container *ngIf="useGoogleCaptcha">
				<!-- Drives the invisible captcha via grecaptcha.execute() (reset-safe)
				     instead of grecaptcha's data-bind click binding (COH-3297). -->
				<button id="form-submit"
												[csLoader]="isWaitingForRequest"
												[loaderAdditionalClasses]="['loader--white']"
												[disabled]="isErrorState"
												(click)="submitWithCaptcha()"
												class="btn btn--primary btn--lg">
					{{'REQUEST_ACCESS_BUTTON' | translate}}
				</button>
			</ng-container>
			<ng-container *ngIf="!useGoogleCaptcha">
				<button
					[csLoader]="isWaitingForRequest"
					[loaderAdditionalClasses]="['loader--white']"
					[disabled]="isErrorState"
					(click)="requestAccess()"
					class="btn btn--primary btn--lg">
					{{'REQUEST_ACCESS_BUTTON' | translate}}
				</button>
			</ng-container>
		</div>
		<button (click)="goBackOfLogout()"
										class="btn btn--white mt-2 btn--lg">
			{{('CANCEL' | translate)}}
		</button>
	</form>
	<p class="card-text login-footer-text">
		{{'IF_YOU_HAVE_PROBLEMS_PERSIST' | translate | capitalize}}
		<a href="mailto:{{loginConfig.supportEmail}}"
					class="link">{{loginConfig.supportEmail}}</a>
	</p>
</div>
